import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { DownloadIcon, BookOpenIcon, MessageCircleIcon } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    icon: <DownloadIcon className="w-8 h-8 text-primary" data-id="element-145" />,
    title: 'Paso 1: Descargás',
    desc: 'Descargás el Pack Bases del Entrenamiento de Fuerza de forma inmediata tras la compra.'
  }, {
    icon: <BookOpenIcon className="w-8 h-8 text-primary" data-id="element-146" />,
    title: 'Paso 2: Consultás',
    desc: 'Consultás los ejercicios y checklists antes de cada clase o entrenamiento.'
  }, {
    icon: <MessageCircleIcon className="w-8 h-8 text-primary" data-id="element-147" />,
    title: 'Paso 3: Respondés',
    desc: 'Respondés con seguridad cada vez que te pregunten "por qué" este ejercicio, sin dudar.'
  }];
  return <section className="py-10 bg-card/50 border-y border-card-border relative overflow-hidden" data-id="element-148">
      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-149">
        <FadeIn className="text-center mb-12" data-id="element-150">
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-151">
            ¿Cómo Funciona?
          </h2>
          <p className="text-xl text-gray-400" data-id="element-152">
            Tres pasos simples para transformar tu seguridad profesional.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-153">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-gradient-to-r from-transparent via-primary/30 to-transparent -z-10" data-id="element-154" />

          {steps.map((step, index) => <FadeIn key={index} delay={0.2 + index * 0.2} direction="up" data-id="element-155">
              <div className="flex flex-col items-center text-center group" data-id="element-156">
                <div className="w-24 h-24 rounded-full bg-background border-2 border-primary/30 flex items-center justify-center mb-8 shadow-[0_0_30px_rgba(245,158,11,0.1)] group-hover:border-primary group-hover:shadow-[0_0_40px_rgba(245,158,11,0.3)] transition-all duration-500 relative" data-id="element-157">
                  <div className="absolute inset-2 rounded-full bg-card flex items-center justify-center" data-id="element-158">
                    {step.icon}
                  </div>
                  {/* Step number badge */}
                  <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-primary text-white font-bold flex items-center justify-center text-sm shadow-lg" data-id="element-159">
                    {index + 1}
                  </div>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-white" data-id="element-160">
                  {step.title}
                </h3>
                <p className="text-gray-400 leading-relaxed px-4" data-id="element-161">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}